/**
 * Returns the property accessor list unchanged while preserving typing.
 *
 * @public
 */ function defineProps(accessors) {
    return accessors;
}

export { defineProps };
//# sourceMappingURL=types.js.map
